module.exports = __webpack_public_path__ + "static/media/air.6d147263.webp";